"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scope = void 0;
var Scope;
(function (Scope) {
    Scope["APP"] = "APP";
    Scope["COMPONENT"] = "COMPONENT";
})(Scope = exports.Scope || (exports.Scope = {}));
//# sourceMappingURL=domain.js.map